import { useState, FormEvent } from "react";

/**
 * edu.photofun.live landing while EDU is not yet runnable in production
 * (Dena, Oct 8, 2026: "Add the coming soon banner to the EDU page and remove
 * the join form for now"). The student join form lives on at /join for the
 * day classes open; this page collects launch interest through
 * joinEduInterest (functions/src/eduInterest.ts), a plain POST so no
 * sign-in is needed. English only, like the rest of the EDU app.
 */
const ENDPOINT = "https://us-central1-photo-fun-live.cloudfunctions.net/joinEduInterest";

export default function ComingSoon() {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("teacher");
  const [school, setSchool] = useState("");
  const [website, setWebsite] = useState(""); // honeypot
  const [state, setState] = useState<"idle" | "sending" | "done" | "error">("idle");

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (state === "sending") return;
    setState("sending");
    try {
      const res = await fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, role, school, website, locale: navigator.language }),
      });
      setState(res.ok ? "done" : "error");
    } catch {
      setState("error");
    }
  };

  return (
    <main className="screen">
      <div className="card">
        <p className="banner">Coming soon</p>
        <h1>PhotoFun EDU</h1>
        <p className="muted">
          Photo scavenger hunts for the classroom: students join with a first name and a class code, no
          accounts, photos auto-delete after 30 days, and the teacher reviews everything. We are finishing
          the classroom rollout and will open it to schools soon.
        </p>
        {state === "done" ? (
          <p className="success">Thanks. You are on the list. We will write when EDU opens, and only about that.</p>
        ) : (
          <form onSubmit={submit}>
            <h2>Hear about the launch</h2>
            <label>
              Email
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </label>
            <label>
              I am a
              <select value={role} onChange={(e) => setRole(e.target.value)}>
                <option value="teacher">Teacher</option>
                <option value="administrator">School administrator</option>
                <option value="parent">Parent</option>
                <option value="student">Student</option>
                <option value="other">Other</option>
              </select>
            </label>
            <label>
              School or district (optional)
              <input value={school} onChange={(e) => setSchool(e.target.value)} maxLength={120} />
            </label>
            <input
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              style={{ position: "absolute", left: "-10000px", width: 1, height: 1, opacity: 0 }}
              name="website"
            />
            {state === "error" && <p className="error">That did not go through. Check the address and try again.</p>}
            <button type="submit" disabled={state === "sending"}>
              {state === "sending" ? "Sending..." : "Notify me"}
            </button>
            <p className="muted small">
              Launch and details announcements only, never shared. Details in the{" "}
              <a href="https://photofun.live/privacy">privacy policy</a>.
            </p>
          </form>
        )}
      </div>
    </main>
  );
}
